import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acces-denied',
  templateUrl: './acces-denied.component.html',
  styleUrls: ['./acces-denied.component.css']
})
export class AccesDeniedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
